<template>
  <div class="forgetPswLayout">
    <el-dialog custom-class="forgetPswDialog" :visible.sync="show" width="4.4rem" :show-close="isShowClose" :before-close="notHideDialog" :modal-append-to-body="false">
      <img loading="lazy" class="forgetPswClose cursorPoint" v-lazy="require('../../static/image/pn/close.png')" @click="closeDialog" />

      <div v-show="forPswArticle == 1">
        <div class="f-title">
          <div class="logTitle">{{$t('forgetPswPage.retrievePassword')}}</div>
          <div class="f-process">
            <div class="f-process-item f-process-1 u-flex-all">1</div>
          </div>
          <div class="first-article first-article1">{{$t('forgetPswPage.firstStep')}}</div>
        </div>

        <div class="regRow regAccountNumber">
          <input class="logInput" :placeholder="$t('loginPage.accountP')" v-model="accountNumber" maxlength="15" @blur="accountBlur" autofocus />
        </div>
        <!-- 验证码 -->

        <div v-if="type === 0" class="regRow regVerifyCode">
          <input type="text" class="logInput" :placeholder="$t('loginPage.verifyCodeP')" v-model="captchaCode" @keyup.enter="submit()" @blur="captchaCode = toCDB(captchaCode)" />
          <div class="verifyCodeImg cursorPoint" v-if="verifyCodeImg" :style="'background-image:url(' + verifyCodeImg + ')'" @click="captchaData"></div>
          <div class="verifyCodeImg getCode u-flex-all cursorPoint" v-if="!verifyCodeImg" @click="captchaData">
            <img loading="lazy" v-lazy="require('../../assets/images/qiqi/refresh.png')" class="refimg" />
            {{$t('loginPage.regain')}}
          </div>
        </div>
        <!-- 行为校验  树莓 -->
        <div v-if="type === 2" id="captcha" class="loginBtn captchaStyle" @click="captchaClick">{{ captchaText }}</div>
        <!--  行为验证 急眼 -->
        <div v-if="type === 1" id="captcha3" class></div>
        <!--  行为验证 极验4 -->
        <div v-show="type === 3" id="gt42" class="mt-b-20"></div>
        <div class="getCode u-flex-all cursorPoint" v-if="errorCode" @click="getDefaultStatus">
          <img loading="lazy" v-lazy="require('../../assets/images/qiqi/refresh.png')" class="refimg" />
          {{$t('loginPage.regain')}}
        </div>

        <div class="registerBtn u-flex-all submit-btn" :class="disabled ? '' : 'cursorPoint hoverShadow'" @click="submit()">{{$t('forgetPswPage.confirmToSubmit')}}</div>

        <div class="regRegister u-flex-all cursorPoint" @click="customerService">
          {{$t('forgetPswPage.isRetrievePassword')}}
          <span class="themeTextColor">{{$t('forgetPswPage.onlineService')}}</span>
        </div>
      </div>

      <div v-show="forPswArticle == 2">
        <div class="f-title">
          <div class="logTitle">{{$t('forgetPswPage.retrievePassword')}}</div>
          <div class="f-process">
            <div class="f-process-item f-process-2 u-flex-all">2</div>
          </div>
          <div class="first-article first-article2">{{$t('forgetPswPage.secStep')}}</div>
        </div>

        <div class="regRow regPhone">
          <div class="phoneVal">{{ myAccount }}</div>
        </div>

        <div class="regRow regPhoneCode">
          <input type="text" class="logInput" :placeholder="$t('forgetPswPage.SMSCodeP')" v-model="phoneCode" @keyup.enter="submit()" />
          <div class="getPhoneCode u-flex-all submit-btn" :class="!isDisable ? 'cursorPoint buttonHover1' : 'disabledPhone'" @click="getPhoneCode">{{ count == 0 ? $t('forgetPswPage.getCode') : count + "s" }}</div>
        </div>

        <div class="registerBtn u-flex-all submit-btn" :class="pDisabled ? 'u-btn-disabled' : 'u-btn-undisabled cursorPoint hoverShadow'" @click="submit()">{{$t('forgetPswPage.confirmToSubmit')}}</div>

        <div class="regRegister u-flex-all cursorPoint" @click="customerService">
          {{$t('forgetPswPage.isRetrievePassword')}}
          <span class="themeTextColor">{{$t('forgetPswPage.onlineService')}}</span>
        </div>
      </div>

      <template v-if="forPswArticle == 3">
        <div class="f-title">
          <div class="logTitle">{{$t('forgetPswPage.retrievePassword')}}</div>
          <div class="f-process">
            <div class="f-process-item f-process-3 u-flex-all">3</div>
          </div>
          <div class="first-article first-article3">{{$t('forgetPswPage.thirdStep')}}</div>
        </div>

        <div class="regRow regPassword">
          <input type="password" class="logInput" :placeholder="$t('forgetPswPage.newPswP')" v-model="password" @blur="passwordBlur" />
        </div>

        <div class="regRow regPassword">
          <input type="password" class="logInput" :placeholder="$t('forgetPswPage.reNewPswP')" v-model="confirmPassword" @blur="confirmPasswordBlur" />
        </div>

        <div class="registerBtn u-flex-all submit-btn" :class="
            pswDisabled ? 'u-btn-disabled' : 'u-btn-undisabled cursorPoint buttonHover1'
          " @click="submit()">{{$t('forgetPswPage.confirmToSubmit')}}</div>

        <div class="regRegister u-flex-all cursorPoint" @click="customerService">
          {{$t('forgetPswPage.isRetrievePassword')}}
          <span class="themeTextColor">{{$t('forgetPswPage.onlineService')}}</span>
        </div>
      </template>
    </el-dialog>

    <!-- 提示弹窗 -->
    <el-dialog custom-class="tipDialog" :visible.sync="tipShow" width="3.88rem" :show-close="isShowClose" :before-close="notHideDialog" :modal-append-to-body="false">
      <div class="tip-title">{{ modalData.title }}</div>
      <div class="tip-content">{{ modalData.content }}</div>

      <div class="tip-btn u-flex-all submit-btn cursorPoint buttonHover1" @click="confirmFn">{{ modalData.confirmText }}</div>
    </el-dialog>
  </div>
</template>

<script>
import { showLogin } from "../../pages/login/login.js";
import gt from "../../utils/gt.js";
import "../../utils/smcp.min.js";
import "../../utils/boc"
export default {
  data() {
    return {
      show: false,
      isShowClose: false,
      forPswArticle: 1,
      accountNumber: "",
      captchaCode: "",
      captchaKey: "",
      verifyCodeImg: "--",
      disabled: true,
      modalData: {
        title: "",
        content: "",
        confirmText: "",
        success: 100 //100为取消  200为确定
      },
      phone: "",
      phoneCode: "",
      count: 0,
      timer: null,
      isDisable: false, //禁止再次发送短信验证码
      pDisabled: true,
      password: "",
      confirmPassword: "",
      pswDisabled: true,
      memberId: "", //用户id
      countSec: 0, //几秒后跳转登录
      timerId: null,
      handLoginFlag: false, //手动点击去登录页面
      type: 1, //行为校验2
      captcha: null, //行为校验
      captchaBox: null,
      captchaText: "",
      captchaMask: false,
      errorCode: false,
      tipShow: false,
      myAccount: '', // 发送验证码时需要的账号
      // 数美请求参数
      smData: {
        lang: '',
        mode: '',
        organization: '',
        product: '',
        appId: '',
        channel: '',
      }
    };
  },
  mounted() { },
  filters: {
    phoneEncode(val) {
      //手机号加密
      if (val) {
        return val.substr(0, 3) + "****" + val.substr(-4);
      }
    }
  },
  methods: {
    // 获取   getDefaultStatus
    getDefaultStatus() {
      let _this = this;
      this.$http.get(this.$api.getDefaultStatus, false).then(res => {
        if (res.code == 0) {
          // type   0：默认验证码  1：极验  2：数美"
          _this.type = res.data.type;
          // _this.type = 1;
          if (_this.type === 0) {
            //图片验证码
            //获取验证码图片
            this.captchaData();
          } else if (_this.type === 1 || _this.type === 3) {
            //1：极验
            _this.disabled = false;
            _this.reset();
          } else if (_this.type === 2) {
            //2：数美"
            Object.assign(_this.smData, res.data);
            _this.reset();
          }
        } else {
          this.errorCode = true;
          this.type = null;
          this.moneyModeListReqSuccess = false;
          this.$message.error(this.$t("loginPage.loadFail"));
        }
      });
    },
    //行为校验↓
    reset() {
      this.check();
      this.getCaptcha();
    },
    check() {
      if(this.type === 3){
        this.captcha && this.captcha.reset()
      } else {
        if (this.captcha) {
          this.captchaText = "";
        } else {
          this.captchaText = this.$t("loginPage.loading");
        }
      }
    },
    getCaptcha() {
      if (this.type == 1) {
        let _this = this;
        this.$http
          .get(
            this.$api.geetFirstRegister,
            "?t=" + window.childCode,
            false
          )
          .then(res => {
            if (res.code == 0) {
              window.initGeetest(
                {
                  gt: res.data.gt,
                  challenge: res.data.challenge,
                  new_captcha: res.data.newCaptcha, // 用于宕机时表示是新验证码的宕机
                  offline:
                    res.data.success === 1 ? false : true, // 表示用户后台检测极验服务器是否宕机，一般不需要关注
                  product: "float", // 产品形式，包括：float，popup
                  width: "100%",
                  lang: "cn"
                },
                _this.onCaptcha
              );
            } else {
              this.$message.error(this.$t("loginPage.getError"));
            }
          });
      } else if (this.type == 2) {
        let data = {
          ...this.smData,
          width: 300,
          https: location.protocol == "https:"
        };
        initSMCaptcha(
          data,
          this.onCaptcha
        );
      } else if(this.type === 3){
        if (!this.captcha) {
            initBotion({
              captchaId: this.$config.captchaId,
              product: 'popup',//float  popup
              language: "zh-cn",
              nativeButton:{
                width: '100%'
                  // width: '1.7rem',
                  // height: '0.3rem'
              }
            }, this.onCaptcha);
        }
      }
    },
    onCaptcha(res) {
      //res是验证实例，可以调用res的示例方法
      var _this = this;
      this.captcha = res;
      if (_this.type == 1) {
        res.appendTo("#captcha3");
        res.onReady(_this.check);
      } else if (this.type == 2) {
        this.captchaText = _this.$t("loginPage.clickBtnToVerify");
        this.captcha.onSuccess(function (data) {
          if (data.pass) {
            _this.disabled = false;
            _this.captcha.rid = data.rid;
            _this.captchaText = _this.$t("loginPage.verifySuccess");
            _this.captchaMask = false;
          } else {
            _this.captcha.rid = null;
            _this.captchaText = _this.$t("loginPage.verifyFail");
          }
        });

        this.captcha.onError(function (errType, errMsg) {
          _this.captcha.rid = null;
          _this.captchaText = _this.$t("loginPage.verifyFail");
          _this.captchaMask = false;
        });

        this.captcha.onClose(function () {
          _this.captchaMask = false;
        });
      } else if(this.type === 3){
        res.appendTo("#gt42")
      }
    },
    captchaClick() {
      if (this.type == 2) {
        var result = this.captcha.getResult();
        var pass = result.pass;
        if (!pass) {
          this.captcha.verify();
          //行为验证bug:点击关闭按钮，会点击穿透
          //解决：手动再添加一个遮罩层
          this.captchaMask = true;
        }
      }
    },
    notHideDialog() { },
    openDialog() {
      this.show = true;
    },
    closeDialog() {
      this.show = false;
    },
    captchaData: async function () {
      let _this = this;
      const res = await this.$http.get(_this.$api.captcha);
      if (res.code == 0) {
        _this.verifyCodeImg = res.data.captcha_image_content;
        // _this.captchaCode = res.data.captchaCode;
        _this.captchaKey = res.data.captchaKey;
      } else {
        //  this.$http.showMesasge(res.msg + "");
      }
    },
    accountBlur() {
      //大写字母强制转化为小写
      this.accountNumber = this.accountNumber.toLowerCase();
      //全角转半角
      this.accountNumber = this.toCDB(this.accountNumber);
      //删除所有空格
      this.accountNumber = this.accountNumber.replace(/\ /g, "");
    },
    toCDB(str) {
      //全角转为半角
      var tmp = "";
      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) == 12288) {
          tmp += String.fromCharCode(str.charCodeAt(i) - 12256);
        }
        if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
          tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
        } else {
          tmp += String.fromCharCode(str.charCodeAt(i));
        }
      }
      return tmp;
    },
    accountIsDisabled() {
      //注册按钮是否禁用
      if (this.type === 0) {
        this.disabled = !(this.accountNumber && this.captchaCode);
      }
    },
    pVerifyIsDisabled() {
      this.pDisabled = !Boolean(this.phoneCode);
    },
    async submit() {
      let captcha3 = document.querySelector("#captcha3");
      var _this = this;
      if (this.forPswArticle == 1) {
        let result = null;
        //禁用
        if (!_this.accountNumber) {
          _this.$http.showMesasge(_this.$t("loginPage.accountE"));
        } else if (this.type === 0 && !this.captchaCode) {
          _this.$http.showMesasge(_this.$t("loginPage.verifyCodeE"));
        }

        if (_this.type != 0) {
          result = _this.captcha.getValidate();
          if (!result) {
            _this.$http.showMesasge(
              _this.$t("loginPage.firstVerify")
            );
            return;
          }
        }

        var params = {
          validateType: _this.type,
          name: _this.accountNumber
        };

        //账号处理
        if (window.mergeAccount) {
          params.name = this.accountNumber + window.mergeAccount;
        }
        if (this.type === 0) {
          params.captchaKey = this.captchaKey;
          params.captchaCode = this.captchaCode;
        } else if (this.type === 1) {
          params.geeTestQueryVO = {
            challenge: result.geetest_challenge,
            seccode: result.geetest_seccode,
            validate: result.geetest_validate
          };
        } else if (this.type === 2) {
          params.shuMeiQueryVO = {
            rid: result.rid
          };
        } else if(this.type === 3){
           params.geeTestQueryVO = result
        }
        var res = await _this.$http.post(
          _this.$api.getMemberByName,
          params
        );
        if (res.code == 0) {
          _this.phone = res.data.phone;
          _this.memberId = res.data.memberId;
          _this.myAccount = _this.accountNumber

          //第一步验证通过
          _this.forPswArticle = 2;
          //数据初始化
          _this.accountNumber = "";
          _this.captchaCode = "";
          _this.captchaData();
        } else {
          //账号有误或者手机未绑定
          var msg =
            _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
            _this.$t("errorCode.webDefault");

          _this.modalData.title = _this.$t("forgetPswPage.Tips");
          _this.modalData.content = msg;
          _this.modalData.confirmText = _this.$t(
            "forgetPswPage.gotIt"
          );
          this.modalData.success = "100";
          _this.tipShow = true;

          //重置行为校验
          if (_this.type === 1) {
            captcha3.innerHTML = "";
          }
          _this.getDefaultStatus();
        }
      } else if (this.forPswArticle == 2) {
        //禁用
        if (_this.pDisabled) {
          if (!_this.phoneCode) {
            _this.$http.showMesasge(
              _this.$t("forgetPswPage.phoneCodeE")
            );
          }
          return;
        }
        var params = {
          name: _this.myAccount,
          phone: _this.phone,
          smsCode: _this.phoneCode
        };

        var res = await _this.$http.post(
          _this.$api.checkSmsCode,
          params
        );
        if (res.code == 0) {
          //第二步验证通过
          _this.forPswArticle = 3;
          //数据初始化
          _this.count = 0;
          clearInterval(_this.timer);
          _this.timer = null;
          _this.isDisable = false;
        } else {
          //短信验证失败
          var msg =
            _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
            _this.$t("errorCode.webDefault");

          _this.modalData.title = _this.$t("forgetPswPage.Tips");
          _this.modalData.content = msg;
          _this.modalData.confirmText = _this.$t(
            "forgetPswPage.gotIt"
          );
          this.modalData.success = "100";
          _this.tipShow = true;

          _this.count = 0;
          clearInterval(_this.timer);
          _this.timer = null;
          _this.isDisable = false;
        }
      } else if (this.forPswArticle == 3) {
        if (_this.pswDisabled) {
          //禁用
          if (!_this.password) {
            _this.$http.showMesasge(
              _this.$t("forgetPswPage.newPswE")
            );
          } else if (!_this.confirmPsw) {
            _this.$http.showMesasge(
              _this.$t("forgetPswPage.reNewPswP")
            );
          }
          return;
        } else {
          //正则校验
          if (!_this.passwordIsValid()) {
            _this.$http.showMesasge(
              _this.$t("forgetPswPage.newPswValid")
            );
            return;
          } else if (!_this.passwordIsconfirmPsw()) {
            _this.$http.showMesasge(
              _this.$t("forgetPswPage.newIsConfirmPsw")
            );
            return;
          }
        }
        var params = {
          memberId: _this.memberId,
          password: _this.password,
          code: _this.phoneCode,
          // phone: _this.phone
          name: _this.myAccount
        };

        var res = await _this.$http.post(
          _this.$api.resetMemberPwdByClient,
          params
        );

        if (res.code == 0) {
          //找回密码成功
          this.modalData.title = _this.$t("forgetPswPage.Tips");
          this.modalData.content = _this.$t(
            "forgetPswPage.modifySuccess"
          );
          this.modalData.confirmText = _this.$t(
            "forgetPswPage.enterLogin"
          );
          this.modalData.success = "200";
          this.tipShow = true;

          //5秒倒计时
          const allSec = 5;
          if (!this.timerId) {
            this.countSec = allSec;
            this.timerId = setInterval(() => {
              if (this.countSec > 1 && this.countSec <= allSec) {
                this.countSec--;
                if (this.handLoginFlag) {
                  //手动点击跳转
                  clearInterval(this.timerId);
                  this.timerId = null;
                } else {
                  this.modalData.content =
                    _this.$t(
                      "forgetPswPage.modifySuccessA"
                    ) +
                    this.countSec +
                    _this.$t("forgetPswPage.aEnterLogin");
                }
              } else {
                clearInterval(this.timerId);
                this.timerId = null;
                _this.tipShow = false;
                _this.show = false;
                // showLogin({
                //   show: true
                // });
              }
            }, 1000);
          }
        } else {
          //修改新密码失败
          // var msg =
          //   _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
          //   _this.$t("errorCode.webDefault");
          var msg = res.msg;
          _this.modalData.title = _this.$t("forgetPswPage.Tips");
          _this.modalData.content = msg;
          this.modalData.confirmText = _this.$t(
            "forgetPswPage.gotIt"
          );
          this.modalData.success = "100";
          this.tipShow = true;
        }
      }
    },
    customerService() {
      if (window.customerServiceStatus == 1) {
        //新客服
        var _this = this;
        var obj = {};
        obj.host = _this.$common.getHost();
        obj.clientCode = window.clientCode;
        obj.clientItem = window.childCode;
        obj.username =
          this.$common.getUser() && this.$common.getUser().username;
        obj.language = this.$common.getLocale();
        obj.theme = window.theme;
        obj.projectImgUrl = window.projectImgUrl;
        obj.orgin = window.location.origin + "/activity";
        var str = JSON.stringify(obj);
        str = window.btoa(str);
        // var url =
        //   _this.$config.customerServiceUrl +
        //   "/customerService/pc?s=" +
        //   str;
        var url = location.origin + "/func/customerService/pc?s=" + str;
        window.open(url, "_blank");
      } else {
        //旧客服
        const url = this.$common.getCustomerService();
        window.open(url, "_blank");
      }
      // let getCustomerService = this.$common.getCustomerService();
      // window.location.href = getCustomerService;
    },
    confirmFn() {
      if (this.timerId && this.modalData.success == 200) {
        //定时器跳login， 就不再次触发了
        this.handLoginFlag = true;
        this.tipShow = false;
        this.show = false;
        // showLogin({
        //   show: true
        // });
      } else {
        this.tipShow = false;
      }
    },
    async getPhoneCode() {
      //获取短信验证码
      var _this = this;
      const TIME_COUNT = 59;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.isDisable = true;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.isDisable = false;
          }
        }, 1000);
        //手机验证码接口
        const res = await _this.$http.get(
          _this.$api.mobilebyacc,
          "/" + _this.myAccount + "?functionId=2"
        );
        if (res.code == 0) {
          //   console.log("获取手机验证码成功");
        } else {
          //   console.log(res.msg, "获取手机验证码失败");
          var msg =
            _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
            _this.$t("errorCode.webDefault");
          this.$http.errMsg(msg);
        }
      }
    },
    passwordBlur() {
      // this.password = this.password.toLowerCase();
      //全角转半角
      this.password = this.toCDB(this.password);
      //删除所有空格
      // this.password = this.password.replace(/\ /g, "");
    },
    confirmPasswordBlur() {
      // this.confirmPassword = this.confirmPassword.toLowerCase();
      //全角转半角
      this.confirmPassword = this.toCDB(this.confirmPassword);
      // this.confirmPassword = this.confirmPassword.replace(/\ /g, "");
    },
    passwordIsValid() {
      //密码校验
      // return /^[a-zA-Z0-9]{6,15}$/.test(this.password);
      return true;
    },
    passwordIsconfirmPsw() {
      //密码和确认密码是否相同
      return this.password == this.confirmPassword;
    },
    pswVerifyIsDisabled() {
      if (this.password && this.confirmPassword) {
        this.pswDisabled = false;
        return;
      }
      this.pswDisabled = true;
    }
  },
  watch: {
    accountNumber() {
      this.accountIsDisabled();
    },
    captchaCode() {
      this.accountIsDisabled();
    },
    phoneCode() {
      this.pVerifyIsDisabled();
    },
    password() {
      this.pswVerifyIsDisabled();
    },
    confirmPassword() {
      this.pswVerifyIsDisabled();
    },
    show(n) {
      if (n) {
        this.getDefaultStatus();
      } else {
        let captcha3 = document.querySelector("#captcha3");
        captcha3 && captcha3.remove();
      }
    }
  }
};
</script>
<style lang="less">
.forgetPswLayout {
  position: relative;
  //   el-dialog

  > .el-dialog__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .forgetPswDialog {
    margin: 0 !important;
    border-radius: 0.1rem;
    .el-dialog__header {
      padding: 0 !important;
    }
    .el-dialog__body {
      padding: 0.32rem 0.46rem 0.5rem;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      border-radius: 0.1rem;
    }
  }
  .forgetPswClose {
    position: absolute;
    top: -0.2rem;
    right: -0.15rem;
    width: 0.4rem;
    height: 0.4rem;
    transition: 1s;
  }
  .forgetPswClose:hover {
    transform: rotate(180deg);
  }
  .f-title {
    margin-bottom: 0.38rem;
    .logTitle {
      height: 0.4rem;
      font-size: 0.16rem;
      color: #2d2b4d;
      margin-bottom: 0.16rem;
      text-align: center;
    }
    .f-process {
      height: 0.02rem;
      background: #ff3a2b;
      position: relative;
      margin-bottom: 0.13rem;
      .f-process-item {
        position: absolute;
        top: -0.07rem;
        width: 0.15rem;
        height: 0.15rem;
        background: #ff3a2b;
        border-radius: 50%;
        color: white;
        font-size: 0.12rem;
      }
      .f-process-1 {
        left: 0.34rem;
      }
      .f-process-2 {
        left: 50%;
        transform: translateX(-50%);
      }
      .f-process-3 {
        right: 0.34rem;
      }
    }

    .first-article {
      height: 0.22rem;
      font-size: 0.14rem;
      font-weight: 500;
      color: #57607e;
      text-align: center;
      opacity: 0.5;
    }
    .first-article1 {
      text-align: left;
    }
    .first-article2 {
      text-align: center;
    }
    .first-article3 {
      text-align: right;
    }
  }

  .regRow {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 0.21rem;
    input {
      flex: 1;
      min-width: 0;
    }
    .phoneVal {
      flex: 1;
      text-align: left;
      height: 0.44rem;
      line-height: 0.44rem;
      background: #fff;
      border: 0.02rem solid #f0f0f0;
      border-radius: 0.1rem;
      font-size: 0.15rem;
      color: #999;
      padding-left: 0.55rem;
      box-sizing: border-box;
    }
    .img {
      position: absolute;
      width: 0.25rem;
      height: 0.25rem;
      top: 50%;
      transform: translateY(-50%);
      left: 0.19rem;
      flex-shrink: 0;
    }
  }

  //短信验证码
  .regPhoneCode {
    width: 100%;
    display: flex;
    align-items: center;
    .getPhoneCode {
      width: 1rem;
      height: 0.44rem;
      border-radius: 0.1rem;
      font-size: 0.14rem;
      padding: 0 0.1rem;
      box-sizing: border-box;
      word-break: break-word;
      margin-left: 0.1rem;
      flex-shrink: 0;
    }

    .disabledPhone {
      background: #f4f4f4;
      border: 1px solid #ccd6e4;
      color: #9695a6;
      box-shadow: none;
    }
  }
  //验证码
  .regVerifyCode {
    display: flex;
    input {
      flex: 1;
    }
    .verifyCodeImg {
      width: 1.2rem;
      height: 0.44rem;
      border-radius: 0.1rem;
      background: #ededed;
      background-size: 100% 100%;
      margin-left: 0.1rem;
      flex-shrink: 0;
    }
  }

  .registerBtn {
    margin: 0 auto 0.18rem;
    height: 0.46rem;
    width: 100%;
  }
  .hoverShadow:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
  }
  .regRegister {
    font-size: 0.12rem;
    height: 0.12rem;
    line-height: 0.13rem;
    text-align: center;
    .themeTextColor {
      color: #ff3a2b;
    }
  }
  #captcha3 {
    margin: 0 0 0.5rem;
    height: 0.44rem;
    border-radius: 0.1rem;
    background: #ededed;
  }

  .getCode {
    height: 0.44rem;
    border-radius: 0.1rem;
    background: #fff;
    border: 0.02rem solid #f0f0f0;
    width: 100%;
    color: #313131;
    .refimg {
      width: 0.22rem;
      vertical-align: middle;
    }
  }

  //提示弹窗
  .tipDialog {
    border-radius: 0.06rem;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 0.4rem 0.5rem;
      font-size: 0.16rem;
      background: linear-gradient(180deg, #f9f9f9, #ffffff, #fafafa) !important;
      border-radius: 0.06rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #313131;
      .tip-content {
        padding: 0.15rem 0 0.27rem;
        box-sizing: border-box;
      }
    }
  }

  .captchaStyle {
    width: 100%;
    background-color: rgba(0,0,0,0.4);
    margin-bottom: 5px;
    &:hover {
      background-color: rgba(0,0,0,0.5);
    }
  }
}

.mt-b-20{
  margin-bottom: 0.2rem;
}
</style>
